import {Component, Inject, LOCALE_ID, OnInit} from '@angular/core';
import {MatIcon} from '@angular/material/icon';
import {MatTooltip} from '@angular/material/tooltip';
import {MatMenu, MatMenuTrigger, MatMenuItem} from '@angular/material/menu';
import {TenantService} from '@twpub/core/services';
import {AVAILABLE_UI_LANGUAGES, UiLanguageOption} from '@twpub/core/models/ui-language';

@Component({
  selector: 'pub-language-switcher',
  templateUrl: './language-switcher.component.html',
  styleUrls: ['./language-switcher.component.scss'],
  standalone: true,
  imports: [MatIcon, MatTooltip, MatMenu, MatMenuTrigger, MatMenuItem]
})
export class LanguageSwitcherComponent implements OnInit {
  availableLanguages: UiLanguageOption[] = [];
  currentLocale: string;
  visible = false;

  switchLanguageLabel = $localize`:@@header.switchLanguage:Switch language`;

  constructor(
    @Inject(LOCALE_ID) localeId: string,
    private tenantService: TenantService
  ) {
    // Normalize locale (e.g. "en-US" -> "en")
    this.currentLocale = localeId.split('-')[0];
  }

  ngOnInit(): void {
    this.tenantService.getCurrentTenant().subscribe({
      next: (config) => {
        const enabled = config.enabledUiLanguages ?? [];
        if (enabled.length >= 2) {
          this.availableLanguages = AVAILABLE_UI_LANGUAGES.filter(l => enabled.includes(l.code));
          this.visible = true;
        }
      }
    });
  }

  switchLanguage(code: string): void {
    if (code === this.currentLocale) return;
    // Each locale is served from /<locale>/ prefix in production.
    // Replace the current locale prefix to switch.
    const currentPath = window.location.pathname;
    const hash = window.location.hash;
    const localePattern = /^\/(en|hu|sv|de)(\/|$)/;
    let newPath: string;
    if (localePattern.test(currentPath)) {
      newPath = currentPath.replace(localePattern, `/${code}$2`);
    } else {
      newPath = `/${code}${currentPath}`;
    }
    window.location.href = newPath + hash;
  }
}
